var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMadpakkehus = function SvgMadpakkehus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#263F54",
    d: "M1 12C1 5.925 5.925 1 12 1h16c6.075 0 11 4.925 11 11v16c0 6.075-4.925 11-11 11H12C5.925 39 1 34.075 1 28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M1 12C1 5.925 5.925 1 12 1h16c6.075 0 11 4.925 11 11v16c0 6.075-4.925 11-11 11H12C5.925 39 1 34.075 1 28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M26.902 26.769v-8.425l-6.898-6.875-6.904 6.875v8.425m2.544-.605h8.712m-7.16 2.185 2.191-2.191m3.42 2.191-2.324-2.317m-.515 3.246v-3.455m.867-.354c.754-.617.982-1.132 1.102-1.838.347-2.024-1.7-3.317-1.7-3.317s-.127 1.257-.875 1.694c-.485-.305-.82-.622-.82-.622s-.378.814-.474 1.227c-.281 1.227.222 2.018 1 2.659.833.676.947 1.09.947 1.09s.21-.468.82-.899z"
  })));
};
export default SvgMadpakkehus;